<template>
  <generic-modal :modal-key="'resubscribe'" :has-extra-modal-class="'popup_box op_down modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
          <h1>{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_modals_resubscribe_successfully_unsubscribe_msg') }}</h1>
          <img class="usericon" src="static/images/unsubscribe.png" alt="">
        <div class="modal__body">
          {{ getTranslations.home_modals_resubscribe_reactivate_account_msg_new }}
        </div>
        <div class="modal__footer">
          <a>
            <a class="ti_btn--main" @click.prevent="reOptin">
              {{ getTranslations.home_modals_resubscribe_resubscribe_new }}
            </a>
          </a>
          <span class="terms">
          {{ getTranslations.home_modals_resubscribe_by_clicking }}
          <br>
           <a style="cursor:pointer" :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.home_modals_resubscribe_request_t_and_cs
             }}</a> {{ getTranslations.home_modals_resubscribe_request_of_the_service }}
        </span>
        </div>
    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './store/ConfirmPurchaseForPinError';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  // It is correct (the name is from previous versions): modal_unsubscribe_confirmation.html
  name: 'resubscribe',
  mixins: [IntegrationMixin],
  components: {
    WelcomeReturningUnsub,
    ResubscribeViaPin,
    GenericModal,
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    goToTermsPage() {
      this.$router.push('/home/terms');
    },
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.storeModalForHomePage(WelcomeReturningUnsub);
              modals.showHideModalForHomePage(this);
            } else {
              this.storeModalForHomePage(ResubscribeError);
              modals.showHideModalForHomePage(this);
            }
          } else {
            // eslint-disable-next-line
            if (this.userDetails.subscribed) {
              this.storeModalForHomePage(ResubscribeError);
              modals.showHideModalForHomePage(this);
            } else {
              this.storeModalForHomePage(ResubscribeViaPin);
              modals.showHideModalForHomePage(this);
            }
          }
        });
      } else {
        this.storeModalForHomePage(ResubscribeError);
        modals.showHideModalForHomePage(this);
      }
    },
    reOptin() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
      'reoptinOnestep',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/Resubscribe.vue